import React from "react";
import AboutUsHeroBanner from "./AboutUsHeroBanner/AboutUsHeroBanner";
import AppTimelineOverview from "./AppTimelineOverview/AppTimelineOverview";
import AppAwardsAccoladesOverviewWidget from "./AppAwardsAccoladesOverviewWidget/AppAwardsAccoladesOverviewWidget";
import OurFoundersWidget from "./OurFoundersWidget/OurFoundersWidget";
import EthicsBanner from "./EthicsBanner/EthicsBanner";
import SEO from "../../components/seo";

import Layout from "../../components/Layout/Layout";
const AboutUs = () => (
    <Layout>
        <SEO
            title="PhonePe - Our Journey"
            description="A Payments App built for India, by Indians! Our Vision is to build India’s largest transaction platform anchored on payments. A scalable ecosystem that creates maximum positive impact for all stakeholders."
            url="https://www.phonepe.com/about-us/"
        />
        <AboutUsHeroBanner />
        <AppTimelineOverview />
        <AppAwardsAccoladesOverviewWidget />
        <OurFoundersWidget />
        <EthicsBanner />
    </Layout>
);

export default AboutUs;
